/**
 * LpToggleMore
 * 「残り○項目を見る」で隠している項目を出し入れする。
 *
 * @usage
 * <div class="js-lp-more" data-more-open="残り4項目を見る" data-more-close="閉じる">
 *   <ul>
 *     <li>…</li>
 *     <li data-more-hidden>…</li>   ← 既定で隠す
 *   </ul>
 *   <button class="js-lp-more-btn" aria-expanded="false">
 *     <span class="body">残り4項目を見る</span>
 *     <span class="ico"></span>
 *   </button>
 * </div>
 *
 * 隠すのは `<html>` に `has-lp-more` が付いてからなので、**JSが動かなければ全件出たまま**になる。
 * 高さのアニメーションは付けない。枚数が多く、開いた高さが端末で変わるため。
 *
 * 開いたときの文言とアイコンの向きは参考HTML準拠
 * （トグルで開閉でき、文言は「閉じる」に変わり、ボタンは残る）。
 */
export default class LpToggleMore {
  /**
   * @param {HTMLElement} element - `.js-lp-more`
   */
  constructor(element) {
    this.element = element;
    this.button = element.querySelector('.js-lp-more-btn');
    this.hidden = Array.from(element.querySelectorAll('[data-more-hidden]'));
    if (!this.button || !this.hidden.length) {
      return;
    }

    this.label = this.button.querySelector('.body') || this.button;
    this.textOpen = element.dataset.moreOpen || this.label.textContent.trim();
    this.textClose = element.dataset.moreClose || '閉じる';
    this.isOpen = false;

    // 隠すのはCSS側。JSが動いた時だけ目印を付ける（LpReveal と同じ流儀）
    document.documentElement.classList.add('has-lp-more');
    this.onClick = this.toggle.bind(this);
    this.button.addEventListener('click', this.onClick);
  }

  toggle() {
    this.isOpen = !this.isOpen;
    this.element.classList.toggle('is-open', this.isOpen);
    this.button.setAttribute('aria-expanded', String(this.isOpen));
    this.label.textContent = this.isOpen ? this.textClose : this.textOpen;

    // 閉じるときに LpReveal の表示済みの印を落としておく。
    // `display: none` になった要素は LpReveal 側の「画面の下へ出た」判定に
    // 引っかからず（矩形が全部0になる）印が残るため、次に開いたときに
    // 順番に出てくる動きが再生されない
    if (!this.isOpen) {
      this.hidden.forEach((el) => {
        el.classList.remove('is-inview');
        el.style.removeProperty('--reveal-index');
      });
    }
  }

  destroy() {
    if (this.button) {
      this.button.removeEventListener('click', this.onClick);
    }
  }
}
